export const listaMateriaisExpediente = [
  { id: 1, nome: 'Açúcar Refinado - Pacote 1kg - Unidade' },
  { id: 2, nome: 'Adoçante(Sacarina) - 100ml - Unidade' },
  { id: 3, nome: 'Adoçante(Sucralose) - 100ml - Unidade' },
  { id: 4, nome: 'Café - Pacote 500g - Unidade' },
  { id: 5, nome: 'Copo Plástico(200ml) - Pacote' },
  { id: 6, nome: 'Copo Plástico(50ml) - Pacote' },
  { id: 7, nome: 'Detergente - 500ml - Unidade' },
  { id: 8, nome: 'Filtro de Café 102 - Caixa com 30 - Unidade' },
  { id: 9, nome: 'Garrafa Térmica - Unidade' },
  { id: 10, nome: 'Guardanapo - Pacote com 50 - Unidade' }
];
